import * as React from "react";

interface DocumentSetDocumentRelationScheduleStatusProps {
  showAfter: string | null;
  showUntil: string | null;
  mixedOverride?: boolean;
  hideStatusText?: boolean;
  hideOverride?: boolean;
}

export default function DocumentSetDocumentRelationScheduleStatus(props: DocumentSetDocumentRelationScheduleStatusProps) {
  const {
    showAfter,
    showUntil,
    mixedOverride,
    hideStatusText,
    hideOverride,
  } = props;

  const showAfterTime = typeof showAfter === "string" && new Date(showAfter);
  const showUntilTime = typeof showUntil === "string" && new Date(showUntil);

  let status = "";
  let className = "";

  if (mixedOverride) {
    status = hideStatusText ? "" : "Mixed";
    className = "mixed-label";
  } else if (showAfterTime && showAfterTime > new Date()) {
    status = `${(showAfterTime.getMonth() + 1)}/${showAfterTime.getDate()}/${showAfterTime.getFullYear()}`;
    className = "visible-after-label";
  } else if (showUntilTime || hideOverride) {
    if (showUntilTime && showUntilTime > new Date()) {
      status = `${(showUntilTime.getMonth() + 1)}/${showUntilTime.getDate()}/${showUntilTime.getFullYear()}`;
      className = "visible-until-label";
    } else {
      status = hideStatusText ? "" : "Hidden";
      className = "hidden-label";
    }
  } else {
    status = hideStatusText ? "" : "Visible";
    className = "visible-label";
  }

  return <p className={className}>{status}</p>;
}
